import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentTemplatesService, OptionsListMulti } from 'gung-common';
import { AuthService } from 'gung-standard';
import { Observable, filter, first, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerDocumentTemplatesService extends DocumentTemplatesService
{

  constructor(protected http: HttpClient, protected authService: AuthService) {
    super(http);
  }

  checkIfIsActuator(): Observable<boolean> {
    return this.authService.getRoles().pipe(
      first(),
      filter(roles => !!roles),
      map(roles => roles.includes('ACTUATOR') || roles.includes('ADMIN'))
    );
  }

  getRolesList(): OptionsListMulti[] {
    const rolesList = super.getRolesList();
    rolesList.push({ id: 'DISTRIBUTOR', name: 'DISTRIBUTOR', selected: false });
    return rolesList;
  }

}
